"use client";

import { recordNpsVisit } from "@/lib/nps/prior-day-session";
import { useEffect } from "react";

/** Headless: accumulate distinct local visit days so NPS can unlock after 2 prior days. */
export function NpsVisitRecorder() {
  useEffect(() => {
    recordNpsVisit();
  }, []);

  return null;
}
